export var AgeGroupFilterType;
(function (AgeGroupFilterType) {
    AgeGroupFilterType["adults"] = "18+";
    AgeGroupFilterType["youngPeople1214"] = "12-14";
    AgeGroupFilterType["youngPeople1517"] = "15-17";
    AgeGroupFilterType["notAvailable"] = "n/a";
})(AgeGroupFilterType || (AgeGroupFilterType = {}));
;
